/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import FamilyHistory from './family-history';
import FamilyHistoryDetail from './family-history-detail';
import FamilyHistoryUpdate from './family-history-update';
import FamilyHistoryDeleteDialog from './family-history-delete-dialog';

const FamilyHistoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<FamilyHistory />} />
    <Route path="new" element={<FamilyHistoryUpdate />} />
    <Route path=":id">
      <Route index element={<FamilyHistoryDetail />} />
      <Route path="edit" element={<FamilyHistoryUpdate />} />
      <Route path="delete" element={<FamilyHistoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default FamilyHistoryRoutes;
